export default __webpack_public_path__ + "static/media/Google_Maps_pin.ceb65638.svg";